// extracted by mini-css-extract-plugin
module.exports = {"container":"Text_container__3ZHW9","toolbar":"Text_toolbar__jdJWV","toolbarButton":"Text_toolbarButton__3Vjl4","editor":"Text_editor__FVFc5","flex1":"Text_flex1__HX5zi"};